import { MediaQuery } from 'hooks/useMediaQuery';

export const BREAKPOINTS: Record<string, MediaQuery> = {
  sm: 768,
  md: 1024,
  lg: 1280,
  xl: 1920,
} as const;
